/**
 * Helper functions for creating consistent status badge classes across the application
 */

/**
 * Creates a status badge class string with consistent styling
 * @param status - The status string to display
 * @returns string with CSS classes for the badge
 */
export const getStatusBadgeClasses = (status: string): string => {
  const baseClasses = 'px-3 py-1 rounded-full text-xs font-semibold';
  
  const statusClasses = status === 'active' ? 'bg-green-100 text-green-700' :
    status === 'suspended' ? 'bg-yellow-100 text-yellow-700' :
    status === 'cancelled' ? 'bg-red-100 text-red-700' :
    'bg-slate-100 text-slate-500';
  
  return `${baseClasses} ${statusClasses}`;
};

/**
 * Creates a subscription status badge class string with consistent styling
 * @param status - The subscription status string to display
 * @returns string with CSS classes for the badge
 */
export const getSubscriptionBadgeClasses = (status: string): string => {
  const baseClasses = 'px-3 py-1 rounded-full text-xs font-semibold';
  
  // Define colors for different status options
  const getStatusColors = (status: string) => {
    switch (status) {
      case 'Active': return 'bg-green-100 text-green-700';
      case 'Design Partner': return 'bg-purple-100 text-purple-700';
      case 'Pilot Customer': return 'bg-blue-100 text-blue-700';
      case 'Paused': return 'bg-yellow-100 text-yellow-700';
      case 'Cancelled': return 'bg-red-100 text-red-700';
      case 'Discontinued DP': return 'bg-gray-100 text-gray-700';
      default: return 'bg-slate-100 text-slate-500';
    }
  };

  const statusClasses = getStatusColors(status);
  
  return `${baseClasses} ${statusClasses}`;
};
